import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import ApiService from '../../../services/apiService';
import './counterSelector.css';
import CounterImg from '../../../../POS/assets/images/Counter.png';
import userManagement from '../../../services/userManagement';
import { getUserId } from '../../../../Redux/selecters';
import { useSelector } from 'react-redux';

const CounterSelector = () => {
  const [counters, setCounters] = useState([]);
  const [filteredCounters, setFilteredCounters] = useState([]);
  const [selectedCounter, setSelectedCounter] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFilter, setSelectedFilter] = useState({ value: 'all', label: 'Show All' });
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const userid = useSelector(getUserId);
  const navigate = useNavigate();

  const filterOptions = [
    { value: 'all', label: 'Show All' },
    { value: 'Available', label: 'Available' },
    { value: 'Occupied', label: 'Occupied' },
  ];

  useEffect(() => {
    fetchCounters();
  }, []);

  useEffect(() => {
    filterCounters();
  }, [counters, searchTerm, selectedFilter]);

  const token = async () => {
    return await localStorage.getItem('Token');
  };
  const fetchCounters = async () => {
    try {
      const apiService = new ApiService();
      const res = await apiService.get('GET_COUNTERS_WITH_STATUS');
      setCounters(res?.data?.result || []);
    } catch (err) {
      console.error('Failed to fetch counters:', err);
    }
  };

  const filterCounters = () => {
    let filtered = [...counters];

    if (selectedFilter.value !== 'all') {
      filtered = filtered.filter((c) => c.counterStatus?.toLowerCase() === selectedFilter.value.toLowerCase());
    }

    if (searchTerm.trim()) {
      filtered = filtered.filter((c) => c.counterName?.toLowerCase().includes(searchTerm.toLowerCase()));
    }

    setFilteredCounters(filtered);
  };

  const handleCounterClick = async (counter) => {
    const currentUser = await userManagement.getUserId(token);
    const status = counter.counterStatus?.toLowerCase();

    if (status === 'available') {
      debugger;
      localStorage.setItem('Counter', JSON.stringify(counter));
      debugger;
      setSelectedCounter(counter);
    } else if (status === 'occupied' && counter.userId === userid) {
      localStorage.setItem('Counter', JSON.stringify(counter));
      // localStorage.setItem('Counter', counter);
      debugger;
      navigate('/Cashier/Home', {
        state: { selectedCounter: counter },
      });
    } else {
      alert('This counter is already occupied by another user.');
    }
  };

  const handleSelect = () => {
    if (!selectedCounter) {
      alert('Please select a counter.');
      return;
    }

    navigate('/Cashier/ShiftOpen', {
      state: { selectedCounter },
    });
  };

  const handleLogout = () => {
    setShowLogoutConfirm(true);
  };

  const confirmLogout = () => {
    // Clear all localStorage items
    localStorage.clear();

    // Alternatively, you can clear specific items:
    // localStorage.removeItem('Token');
    // localStorage.removeItem('Counter');
    // localStorage.removeItem('user');
    // Add any other items you want to clear

    setShowLogoutConfirm(false);

    // Navigate to login page
    // navigate('/Login');
    window.location.href = 'https://app.pro360erp.com';
  };

  const cancelLogout = () => {
    setShowLogoutConfirm(false);
  };

  const getCardClass = (counter) => {
    if (selectedCounter?.counterId === counter.counterId) return 'counter-card selected';
    return counter.counterStatus?.toLowerCase() === 'available' ? 'counter-card available' : 'counter-card occupied';
  };

  return (
    <div className="counter-container p-5">
      <div className="p-5">
        {/* Top Header with Logout */}
        <div className="top-header">
          <div className="header-left">
            <h2 className="app-title">Point of Sale System</h2>
            <p className="header-subtitle">Select your till to continue</p>
          </div>
          <div className="header-right">
            <div className="user-info">
              <span className="user-greeting">Welcome back!</span>
            </div>
            <button className="logout-btn" onClick={handleLogout} title="Logout">
              <svg className="logout-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16,17 21,12 16,7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
              Logout
            </button>
          </div>
        </div>

        <div className="p-5 card enhanced-main-card">
          <div className="mb-3">
            <h3 className="Headtxt">Select Till</h3>
          </div>

          <div className="counter-header enhanced-header mb-4">
            <div className="filter-section">
              <label className="filter-label">Filter by status:</label>
              <Select
                value={selectedFilter}
                onChange={setSelectedFilter}
                options={filterOptions}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  control: (base) => ({
                    ...base,
                    borderColor: '#6e5199',
                    '&:hover': { borderColor: '#6e5199' },
                  }),
                }}
              />
            </div>
            <div className="search-section">
              <label className="search-label">Search:</label>
              <div className="search-input-wrapper">
                <svg className="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="11" cy="11" r="8" />
                  <path d="m21 21-4.35-4.35" />
                </svg>
                <input
                  type="text"
                  className="counter-search enhanced-search"
                  placeholder="Search tills..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="results-info">
            <span className="results-count">
              Showing {filteredCounters.length} of {counters.length} tills
            </span>
          </div>

          <div className="counter-grid enhanced-grid p-3">
            {filteredCounters.map((counter) => (
              <div key={counter.counterId} className={`${getCardClass(counter)} enhanced-counter-card`} onClick={() => handleCounterClick(counter)}>
                <div className="counter-image-section mb-3">
                  <img src={CounterImg} alt="Counter" className="counter-image" />
                  <div className={`status-indicator ${counter.counterStatus?.toLowerCase()}`}></div>
                </div>

                <div className="counter-info">
                  <div className="text-lg font-bold counter-name">{counter.counterName}</div>
                  <div className="counter-id">Till ID: {counter.counterId}</div>
                </div>

                {counter.counterStatus?.toLowerCase() === 'occupied' && (
                  <div className="counter-user enhanced-user-info">
                    <span className="user-name">{counter.usedBy || 'Employee Name'}</span>
                    {counter.userId === userid && <span className="you-badge">Opened by you</span>}
                  </div>
                )}
              </div>
            ))}
          </div>

          {filteredCounters.length === 0 && (
            <div className="empty-state">
              <div className="empty-icon">🔍</div>
              <h4>No tills found</h4>
              <p>Try adjusting your search or filter criteria</p>
            </div>
          )}

          <div className="counter-footer enhanced-footer mt-4">
            <button className="AddBtn enhanced-cancel-btn">Cancel</button>
            <button className="addItem-btn enhanced-select-btn" onClick={handleSelect} disabled={!selectedCounter}>
              {selectedCounter ? `Select ${selectedCounter.counterName}` : 'Select Till'}
            </button>
          </div>
        </div>
      </div>

      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div className="logout-modal-overlay">
          <div className="logout-modal">
            <div className="modal-header">
              <h4>Confirm Logout</h4>
              <svg className="warning-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to logout? This will clear all your session data.</p>
            </div>
            <div className="modal-footer">
              <button className="cancel-logout-btn" onClick={cancelLogout}>
                Cancel
              </button>
              <button className="confirm-logout-btn" onClick={confirmLogout}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16,17 21,12 16,7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CounterSelector;
